import { connect } from 'react-redux';
import { changeFilter } from '../../../redux/actions/filter';
import { getOperatorData } from '../../../redux/actions/operator';
import { FilterMain } from '../../Filters';

const mapStateToProps = state => ({
  filters: state.filter.filters,
  operatorData: state.operator.data,
  loading: state.operator.loading,
  initialValues: state.auth.user.config && state.auth.user.config.dashboard ? state.auth.user.config.dashboard.filters : null
})

const mapDispatchToProps = { getOperatorData, changeFilter };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterMain)



// WEBPACK FOOTER //
// ./src/components/Panels/PanelHomeComponent/FilterMainConnected.js